require('./cardSelectorButton.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class CardSelectorButton extends React.Component {
    render() {
        const { className, onClick } = this.props;
        const isNext = className === 'slick-arrow slick-next';
        const isPrev = className === 'slick-arrow slick-prev';
        const buttonClassName = classNames(
            'card-selector-button',
            { 'card-selector-button--next': isNext },
            { 'card-selector-button--prev': isPrev }
        );

        return <button className={buttonClassName} onClick={onClick}></button>;
    }
}

CardSelectorButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};

module.exports = CardSelectorButton;
